module.exports = __webpack_public_path__ + "static/media/dice.01607557.svg";